<template>
  <transition name="fade">
    <div
      class="card-block car-block"
      :class="{
        'card': mode === 'card',
        'inner': mode === 'inner' || mode === 'visit',
        'visit': mode === 'visit',
      }"
      v-if="car"
    >
      <div class="header">
        <div>
          <p
            class="car-model"
            v-if="carModel"
          >
            {{ carModel }}
          </p>
          <p
            class="car-engine"
            v-if="carEngine"
          >
            {{ carEngine }}
          </p>
        </div>
        <div
          v-if="mode === 'visit'"
          class="spacer"
        />
        <p
          class="car-vin-number"
          v-if="car.vin"
        >
          {{ car.vin.toUpperCase() }}
        </p>
        <p
          class="car-license-plate"
          v-if="car.licensePlate"
        >
          {{ car.licensePlate.toUpperCase() }}
        </p>
      </div>
      <div class="car-content">
        <img
          class="car-image"
          v-if="car.imgSrc"
          :src="car.imgSrc"
          alt=""
        >
      </div>
      <div
        class="car-footer"
        v-if="mode === 'card'"
      >
        <div class="next-visit">
          <p
            class="next-visit-date"
            v-if="nextVisitDate"
          >
            Zbliżająca się wizyta: <br>
            <span>
              {{ formatDate(nextVisitDate) }}
            </span>
          </p>
          <p v-else>
            Brak zbliżających się wizyt
          </p>
        </div>
      </div>
      <div
        class="controls-container"
        v-if="mode === 'card' || mode === 'inner'"
        :class="{ 'mobile' : isMobile }"
      >
        <button
          class="visit-control-button"
          v-if="mode === 'card'"
          @click="goTo(`/dashboard/visits/new/${carModelID}/station`, 'new_visit')"
          v-tooltip.left="{ content: 'Umów nową wizytę', classes: 'car-block-tooltip' }"
        >
          <svg class="icon" svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="49" height="49" viewBox="0 0 49 49"><image width="49" height="49" xlink:href="data:image/png;base64,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"/></svg>
        </button>
        <button
          class="visit-control-button"
          v-if="mode === 'card'"
          @click="goTo(`/dashboard/visits/next/${car.id}`, 'planned_visits')"
          v-tooltip.left="{ content: 'Zaplanowane wizyty', classes: 'car-block-tooltip' }"
        >
          <svg class="icon" svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46" height="49" viewBox="0 0 46 49"><image width="46" height="49" xlink:href="data:image/png;base64,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"/></svg>
        </button>
        <button
          class="visit-control-button"
          v-if="mode === 'card'"
          @click="goTo(`/dashboard/visits/history/${car.id}`, 'visit_history')"
          v-tooltip.left="{ content: 'Historia wizyt', classes: 'car-block-tooltip' }"
        >
          <svg class="icon" svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46" height="46" viewBox="0 0 46 46"><image width="46" height="46" xlink:href="data:image/png;base64,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"/></svg>
        </button>
        <button
          class="visit-control-button"
          v-if="mode === 'card'"
          @click="goTo(`/dashboard/carinfo/${car.id}`, 'car_info')"
          v-tooltip.left="{ content: 'Informacje o samochodzie', classes: 'car-block-tooltip' }"
        >
          <svg class="icon" svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46" height="46" viewBox="0 0 46 46"><image width="46" height="46" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAEfElEQVRoQ9WaTWwbVRDH//MWk9r9AMSBAgd6QKRVlDWotBAKiCDUEtsBCanpOq0oJ6CAhFSpcMQcAakSElDgRFGTbFIJCWI7FKEGQdtAoAJvFKWJOBQJSjkgoB9Og9l9aHbXwYntJGvvAvuO2bezvzeZN/Of90xociSG2tZDKp0kcR+AjQBuA3AtgNWu6csAfgcwA+CMJHwBMkfzPZPnm/k0NfLyzqG2NUVL9AJiLyDvqWOj5P49Uvs5nQKswzFh9R/tmbzklcMTeNeRu9Ypyux+CTwHwvXux4ogfC4ljgtQwTLFtLzu4vmRxPdz/Lwrf2sL/bZ2vVCsVgsyToQHIXE/gJj9vsSvBLxhmtGDI3u+urDSBawYPDUQ3yVJHgRwExsn4EsAh6LC/MCrx/g/NmspjwHYJ4G7XdhzJGl/Nl0YXAn8suCPfNi61pxddQiQu10PjRPEi9n0d5+t5APLzUkN3P6AhPUKCFududSnRK/s++jR6YtLvbskeKLvjltIMT9xN1wRwIEtZ4y3MxlYywF5eZ7JQHy9UX0awGtuCM1IU9me3/3tD/Xs1AVPDLW3k0UjAG4GMCUs2jncW5j0AuR1bnd/vM0S8iiATQB+kkJ25XsmJmrZqQnuevqkDS1xYk6JpD7tOf2HV5BG5j80tPmaFrOUBeFeG95UttXyfBW4E9Mt39jhIXFCrInsGO4+zWHyr43u4c0x61LpmAs/o0Tn7lwc81XgST1+xN2IU3Mi0tGop5MD6nu80lzaeKKRFduet0pjTthQX04r7Km0swDcTXk6gKKwaGszMZ3UVWmDa8aymavewtyYH+cNS5K0ylQ5b5SLi7hqdsrN08/mNOOtRjxVfscPcLaV1NVnALwJ4Jz1V3RTuUjNg6cG1IwkvASJ8S3TRkezKc8vcDtVtqpjnOdJ4uVs2si4BRCwtYepnOUyTlJ0+lFc/AJnSLtIkTXK8iCmmBu4UtseT+rtTwL0DpfxrGZ0NBMifodK2V5KV8cceSCfymkT77rg8ZOs8gjYm9WM9/+n4I9L4DBAp3JaYRuxniZL+ZkzSUyYN3gVTPUW6Weo8DccKa38whlGCvNGSgyqaZLoB+Hj3C6jyw9vu9mg6XS4mCU5qI5A4mFJ6KWkrnLaY3n5Ql4zWOT4Mvz2OEMldPUAAa+ynGbw4wA6CbQjqxVYCfoyggBP6fHtEvIYgFEG/5HFlDSVDUvJSK+rCQLcFX9nWXwxOPd7q611xVXldssrZK35QYBzGyguxK4AuMzgvIlKOc242g/goPJ4hd0/AURCDR7aUAnt5gwqHdpdU04znPMTH8bidBhIAWJFx6x+KM3ymhcUoKBKvg8OrjKxoOQHJbL8Bq8SWY4g8l/W+g2e0tWFstYB97+RCAC8upEIonVL6erz9ubUjNebXUTd1o0NB9Asm246VJoBX7JZZsOhPZ5wvG6fgYfrQOgf9RXCIziGD+2hJ8OH8ph5XheE8WB/Hj6MVyll+FBeXlUWjtBdF1bCh/KCtnIBobsSr6U5/qsfIfwNmaAbXv/lN/YAAAAASUVORK5CYII="/></svg>
        </button>
        <button
          class="visit-control-button"
          v-if="mode === 'inner'"
          @click="deleteCarModal()"
          v-tooltip.left="{ content: 'Usuń samochód', classes: 'car-block-tooltip' }"
        >
          <svg svg-inline="" class="icon" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 9v10.5c0 .5.4 1 1 1h10c.5 0 1-.5 1-1V9m-6-3.5v-2m-1.5 0h3m-9.5 4h16l-1.4-2H4.9l-1.4 2z" stroke="currentColor" fill="none"/></svg>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ajax from '@/helpers/ajax';
import config from '@/config';
import dayjs from 'dayjs';
import maxBy from 'lodash/maxBy';

export default {
  props: {
    car: {
      default: () => {},
      type: Object,
    },
    mode: {
      default: 'card',
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
      thirdColor: 'brand/getThirdColor',
      allCars: 'brand/getSpecificModels',
    }),
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    carModel() {
      const { brand, model } = this.car;
      if (brand && model) {
        return `${brand} ${model.toUpperCase()}`;
      }
      return '';
    },
    carEngine() {
      const {
        capacity, engine, power, transmission, quattro, hasLPG,
      } = this.car;

      let name = `${capacity} ${engine.toUpperCase()} ${power} KW ${transmission.toUpperCase()}`;

      if (quattro) {
        name = `${capacity} ${engine.toUpperCase()} ${power} KW 4x4 ${transmission.toUpperCase()}`;
      }

      if (hasLPG) {
        name = `${name} LPG`;
      }

      return name;
    },
    nextVisitDate() {
      const visitDates = this.car.visits.map(visit => ({
        status: visit.status,
        date: visit.date,
        diff: dayjs().diff(dayjs(visit.date)),
      })).filter(visit => visit.diff < 0 && visit.status !== 'Odwołana');
      const nextDate = maxBy(visitDates, visit => visit.diff);
      return nextDate !== undefined ? nextDate.date : null;
    },
    carModelID() {
      return this.allCars.find(carModel => carModel.name === this.car.name).id || null;
    },
  },
  methods: {
    ...mapActions({
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
      removeCar: 'myCars/removeCar',
      setModalStep: 'modal/setModalStep',
      setModalMode: 'modal/setModalMode',
      setSelectedLicensePlate: 'visit/setSelectedLicensePlate',
      setSelectedVin: 'visit/setSelectedVin',
      setShowHistoryVisits: 'visit/setShowHistoryVisits',
      setSelectedPartner: 'visit/setSelectedPartner',
      setSelectedServices: 'visit/setSelectedServices',
      setSelectedVisitDate: 'visit/setSelectedVisitDate',
      setRegisteredVisit: 'visit/setRegistered',
      setSelectedCarModelID: 'visit/setSelectedCarModelID',
      setMileage: 'visit/setMileage',
    }),
    formatDate(date) {
      return dayjs(date).format('DD-MM-YYYY hh:mm');
    },
    goTo(path, name) {
      if (name === 'new_visit') {
        this.resetVisitSpecs();
        this.setSelectedCarModelID(this.carModelID);
        this.setSelectedLicensePlate(this.car.licensePlate);
        this.setSelectedVin(this.car.vin);
      }
      if (name === 'planned_visits') {
        this.setShowHistoryVisits(false);
      }
      if (name === 'visit_history') {
        this.setShowHistoryVisits(true);
      }

      this.$router.push({ path });
    },
    deleteCar() {
      const endpoint = config.apiEndpoints.deleteCar.replace('id', this.car.id);

      ajax.delete(endpoint)
        .then((res) => {
          if (res.status === 200) {
            this.closeModal();
            this.removeCar(this.car.id);
            this.$router.push({ path: '/dashboard/mycars' });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    deleteCarModal() {
      this.setModalContent({
        title: 'Usuwanie samochodu',
        html: `
        <div class="remove-car">
          <br />
          <p class="modal-text">
            Czy na pewno chcesz dokonać usunięcia wybranego samochodu?
            <br><br>
            Uwaga: Akcja jest nieodwracalna.
            Utracisz wszystkie dane dotyczące usuwanego samochodu oraz historię wizyt,
            w tym również tych zbliżających się.
            Usunięcie samochodu nie spowoduje odwołania aktualnie zaplanowanych wizyt!
          </p>
        </div>
          `,
        confirm: 'Potwierdzam',
        cancel: 'Anuluj',
      });

      this.setCallback(this.deleteCar);
      this.toggleModal();
    },
    resetVisitSpecs() {
      this.setMileage(0);
      this.setSelectedPartner(null);
      this.setSelectedServices(null);
      this.setSelectedVisitDate(null);
      this.setRegisteredVisit(null);
    },
  },
};
</script>
